import {useState} from 'react'
import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import ModalFooter from '@/customComponents/uiComponents/modal/ModalFooter.jsx'

/**
 * "YOU'RE AT THE PICKUP POINT" — raised by `useReachedPickupGeofence` the moment the app
 * reports the passenger there, so they understand the driver now knows too.
 *
 * Global, mounted in `AppLayout` beside the other self-raising dialogs (it must survive
 * navigation, or it would vanish if the passenger changed page as the report landed). It
 * opens ONCE per report: `tripId` changes only when a report actually went out, and an
 * `already_reported` answer never reaches here.
 */
export default function ReachedPickupModal({tripId}) {
    /* Derived, not synchronised: open while a report exists that has not been dismissed. A new
       report (another trip id) opens it again; closing sticks for the one already shown. */
    const [dismissedFor, setDismissedFor] = useState(null)
    const open = tripId != null && String(tripId) !== String(dismissedFor)
    const close = () => setDismissedFor(tripId)

    return (
        <Modal isOpen={open} onClose={close}>
            <ModalHeader title="You're at the pickup point" onClose={close}/>

            <div className="flex flex-col gap-3 text-center">
                <p className="mb-0! text-(--text-primary)">
                    We've let your driver know you've arrived at the pickup point.
                </p>
                <p className="mb-0! text-(--text-secondary)">
                    Stay where you are. Your driver will meet you here.
                </p>
            </div>

            <ModalFooter>
                <button
                    type="button"
                    onClick={close}
                    className="bg-(--text-primary) text-white text-center rounded-full w-full p-3 hover:opacity-80 cursor-pointer"
                >
                    Got it
                </button>
            </ModalFooter>
        </Modal>
    )
}

export {ReachedPickupModal}
